import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormSelect from "../form/FormSelect";
import {getUserAssignmentTypeList} from '../../libs/user';
import Grid from '@material-ui/core/Grid';
import {withStyles} from '@material-ui/core';
import LocationContainer from '../../containers/Location';



const styles = () => {
	return {}
};

class EquipmentScheduleTypeSelect extends PureComponent {
	componentDidMount() {
		const { locations, searchLocations } = this.props;
		if (_.isEmpty(locations)) {
			searchLocations();
		}
	}

	render () {
		const { locations, selectedLocationId } = this.props;

		const pickToShow = {
			padding: 20,
			background: '#f7f7f7',
			border: '1px solid #ddd',
			color: '#333',
			borderRadius: 2,
		};

		if (!selectedLocationId || _.isEmpty(locations)) {
			return (<Grid item xs={12}>
				<div style={pickToShow}>
					Pick a terminal first to see available Schedule Types
				</div>
			</Grid>);
		}

		const location = _.find(locations, { locationId: selectedLocationId });
		if (!location || !location.state) {
			return (<Grid item xs={12}>
				<div style={pickToShow}>
					Pick a terminal first to see available Schedule Types
				</div>
			</Grid>);
		}

		const { state } = location;
		const optionsForState = _.filter(getUserAssignmentTypeList(), { state }).map(userAssignmentType => {
			return {
				value: userAssignmentType.userAssignmentTypeId,
				display: userAssignmentType.display,
			};
		});

		return (
			<FormSelect
				{...this.props}
				options={optionsForState}
			/>
		);
	}
}

EquipmentScheduleTypeSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,
	classes : PropTypes.object,
	helpText : PropTypes.string,
	selectedLocationId: PropTypes.number,
};

export default _.flow([
	withStyles(styles),
	LocationContainer,
])(EquipmentScheduleTypeSelect);
